import { render, staticRenderFns } from "./PaywallFormPackageButtons.vue?vue&type=template&id=749b0c23&scoped=true"
import script from "./PaywallFormPackageButtons.vue?vue&type=script&lang=js"
export * from "./PaywallFormPackageButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749b0c23",
  null
  
)

export default component.exports